import { ActiveInactiveStatusEnum } from '../../../../../../../shared/enums/active-inactive-status.enum';
import { firmwareOverviewStatusMap } from '../../../../../../firmware-management/utils/firmware-overview-status.map';
import TableDateCell from '../../../../../../shared/components/table-cells/TableDateCell/TableDateCell';
import { Alignments } from '../../../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../../../shared/components/ui/Table/models/table-column.model';
import { TextToColorMapModel } from '../../../../../../shared/models/text-to-color-map.model';
import { castTo } from '../../../../../../shared/utils/cast-to';
import { MapToText } from '../../../../../../shared/utils/map-to-text/map-to-text.util';
import { CampaignOverviewModel } from '../../../../../models/campaign-overview.model';
import CampaignsDetailsCell from '../components/campaigns-details-cell/campaigns-details-cell';

export const campaignsOverviewTableColumnsDef: TableColumnDef[] = [
  {
    field: 'campaign',
    headerName: 'Name',
    alignment: Alignments.LEFT,
    width: '62.3%',
    valueGetter: row => (
      <CampaignsDetailsCell {...castTo<CampaignOverviewModel>(row)} />
    ),
  },
  {
    field: 'startDate',
    headerName: 'Start',
    alignment: Alignments.LEFT,
    width: '14.3%',
    valueGetter: row => {
      return (
        <TableDateCell
          date={castTo<CampaignOverviewModel>(row).startDate}
        ></TableDateCell>
      );
    },
  },
  {
    field: 'endDate',
    headerName: 'End',
    alignment: Alignments.LEFT,
    width: '14.3%',
    valueGetter: row => {
      return (
        <TableDateCell
          date={castTo<CampaignOverviewModel>(row).endDate}
        ></TableDateCell>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    alignment: Alignments.RIGHT,
    width: '5.87%',
    valueGetter: row =>
      MapToText<ActiveInactiveStatusEnum, TextToColorMapModel>({
        map: firmwareOverviewStatusMap,
        property: row.status as ActiveInactiveStatusEnum,
      }),
  },
];
